export default __webpack_public_path__ + "static/taskdef1-8b21b8367490b5ab57e1cf5aefe74911.png";